// core version + navigation, pagination modules:
"use client";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "./product_slide_show.css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";

import { Box, Button, Stack, styled, Typography } from "@mui/material";
import { TitleGradientText } from "../title_gradient_text";
import { mockRootProps } from "@/data/products_mock_data";
import Image from "next/image";
import { useState } from "react";
import { useRouter } from "next/navigation";

const BlackDropBlur = styled(Box)`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: calc(100% + 1px);
  z-index: -1;
  background-color: rgba(11, 17, 20, 0.01);
  backdrop-filter: blur(150px);
`;

export function ProductSlideShow() {
  const { products } = mockRootProps;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [sw, setSw] = useState<any>();
  const router = useRouter();

  const handleProductsClick = () => {
    router.push("/products");
  };

  return (
    <Stack
      id="home_product"
      className="product-slide-show-wrapper"
      alignItems="center"
      py={{
        xs: 15,
        md: 27,
      }}
      px={{
        xs: 4,
        md: 30,
      }}
      gap={15}
      width="100%"
      overflow="hidden"
      position="relative"
    >
      {/* <BgBallCenter width={238} height={148} />
      <BgBallBottom height={160} width="100%" /> */}
      <Box
        position="absolute"
        zIndex={-2}
        left={`calc(50% - 119px)`}
        top={`calc(40% - 74px)`}
      >
        <Image
          src="/images/home/slide_bg_center.png"
          width="238"
          height="148"
          alt=""
        />
      </Box>
      <Box
        position="absolute"
        zIndex={-2}
        left="0"
        bottom={{ xs: -70, md: -100 }}
      >
        <Box width="100vw" height="160px" position="relative">
          <Image src="/images/home/slide_bg_bottom.png" fill alt="" />
        </Box>
      </Box>
      <BlackDropBlur />
      <Stack alignItems="center">
        <TitleGradientText
          mt={4}
          variant="h3"
          fontWeight={600}
          fontSize={{
            xs: "32px",
            md: "48px",
          }}
          textAlign="center"
        >
          หลากหลายความอร่อย
        </TitleGradientText>
        <TitleGradientText
          mt={4}
          variant="body1"
          fontSize={{
            xs: "20px",
            md: "24px",
          }}
          textAlign="center"
        >
          น้ำปลาร้า น้ำจิ้มเนื้อวัวและอื่น ๆ
        </TitleGradientText>
      </Stack>
      <Box
        display={{
          xs: "none",
          md: "flex",
        }}
        width={36}
        height={36}
        bgcolor="#17232B"
        justifyContent="center"
        alignItems="center"
        borderRadius="50%"
        sx={{
          transform: "rotate(225deg)",
          cursor: "pointer",
        }}
        left={{
          xs: 16,
          md: 100,
        }}
        top="calc(50% - 30px)"
        position="absolute"
        zIndex={5}
        onClick={() => sw?.slidePrev()}
      >
        <Image src="/svg/arrow.svg" width="14" height="14" alt="" />
      </Box>
      <Box
        display={{
          xs: "none",
          md: "flex",
        }}
        width={36}
        height={36}
        bgcolor="#17232B"
        justifyContent="center"
        alignItems="center"
        borderRadius="50%"
        sx={{
          transform: "rotate(45deg)",
          cursor: "pointer",
        }}
        right={{
          xs: 16,
          md: 100,
        }}
        top="calc(50% - 30px)"
        position="absolute"
        zIndex={5}
        onClick={() => sw?.slideNext()}
      >
        <Image src="/svg/arrow.svg" width="14" height="14" alt="" />
      </Box>
      <Stack
        width="100%"
        height="410px"
        sx={{
          overflowX: "hidden",
        }}
      >
        <Swiper
          spaceBetween={20}
          onSlideChange={() => console.log("slide change")}
          onSwiper={(swiper) => setSw(swiper)}
          modules={[Pagination]}
          wrapperClass="card-section-wrapper"
          slidesPerView="auto"
          pagination={{
            clickable: true,
            bulletActiveClass: "swiper-pagination-bullet-active",
            bulletClass: "swiper-pagination-bullet",
          }}
        >
          {products.map((product, index) => (
            <SwiperSlide key={index}>
              <Stack
                width="fit-content"
                height="fit-content"
                justifyContent="center"
                alignItems="center"
                gap={5}
              >
                <Stack width="285px" height="285px">
                  <Image
                    src={product.image}
                    width={520}
                    height={520}
                    style={{
                      width: "100%",
                      height: "auto",
                      objectFit: "contain",
                      borderRadius: "16px",
                    }}
                    alt="Picture of the Logo"
                  />
                </Stack>
                <Stack gap={2}>
                  <Typography variant="subtitle1" textAlign="center">
                    {product.name}
                  </Typography>
                  <Typography
                    variant="caption"
                    textAlign="center"
                    color="textSecondary"
                  >
                    {product.size}
                  </Typography>
                  <Typography variant="caption" textAlign="center">
                     ราคา - บาท
                  </Typography>
                </Stack>
              </Stack>
            </SwiperSlide>
          ))}
        </Swiper>
      </Stack>
      <Stack>
        <Button variant="contained" onClick={handleProductsClick}>
          <Stack direction="row" alignItems="center" gap={1}>
            <Typography variant="button" color="textPrimary">
              ผลิตภัณฑ์ทั้งหมด
            </Typography>
            <ArrowForwardRoundedIcon
              style={{
                color: "#fff",
              }}
            />
          </Stack>
        </Button>
      </Stack>
    </Stack>
  );
}
